import { createReducer } from 'redux-act';

import {
  WEB_CONTENTS_FETCH,
  WEB_CONTENTS_FETCH_DATA_SUCCESS,
  WEB_CONTENTS_FETCH_DATA_FAIL,
  WEB_CONTENTS_DELETE_INIT,
  WEB_CONTENTS_DELETE_SUCCESS,
  WEB_CONTENTS_DELETE_FAIL,
  WEB_CONTENTS_CLEAR_DATA,
  WEB_CONTENTS_CREATE_INIT,
  WEB_CONTENTS_CREATE_SUCCESS,
  WEB_CONTENTS_CREATE_FAIL,
  WEB_CONTENTS_MODIFY_INIT,
  WEB_CONTENTS_MODIFY_SUCCESS,
  WEB_CONTENTS_MODIFY_FAIL,
  WEB_CONTENTS_CLEAN_UP,
  WEB_CONTENTS_CLEAR_DATA_LOGOUT,
  SET_WEB_CONTENTS,
} from 'state/actions/webContents';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webContentsReducer = createReducer(
  {
    [WEB_CONTENTS_FETCH]: () => ({
      ...initialState,
      loading: true,
    }),
    [WEB_CONTENTS_FETCH_DATA_SUCCESS]: (state, payload) => {
      console.log('payload web contnet', payload);
      return {
        ...state,
        list: payload.WEB_CONTENTS.data || [],
        loading: false,
        error: null,
      };
    },
    [WEB_CONTENTS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_CONTENTS_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_CONTENTS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [WEB_CONTENTS_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_CONTENTS_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [WEB_CONTENTS_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_CONTENTS_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_CONTENTS_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_CONTENTS_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_CONTENTS_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return {
                _id: payload.id,
                name: payload.informationCategory.name,
                description: payload.informationCategory.description,
                siteId: payload.informationCategory.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.informationCategory.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_CONTENTS_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_CONTENTS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [WEB_CONTENTS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_WEB_CONTENTS]: (state, payload) => ({
      ...state,
      category: payload.data,
    }),
  },
  initialState
);
